export enum EFirestoreCollections {
  MERCHANT_THEME = 'merchant-theme',
  MERCHANT_THEME_SNAPSHOT = 'merchant-theme-snapshot-06-17-2025T16:26:00-CST',
}
